import Default from './default';

const Modal = Default;

export {
  Default,
  Modal,
};


// WEBPACK FOOTER //
// ./src/components/modal/index.ts